<div class="flex items-center justify-end flex-1 gap-4">
    @if (selectionService.isSelectionActive()) {
        <app-button
            [disabled]="!isEntitySelected()"
            [icon]="['fas', 'arrow-down-to-line']"
            [tooltip]="isEntitySelected() ? '' : ('selectEntitiesToExport' | transloco)"
            [type]="ButtonType.SECONDARY"
            (click)="dataExportService.openShapeExportModal(ExportSelectionModeEnum.ENTITY_SELECTION)" />
    }
    <app-button
        [icon]="['fas', 'arrow-pointer']"
        [label]="selectionService.isSelectionActive() ? '' : ('select' | transloco)"
        [type]="selectionService.isSelectionActive() ? ButtonType.TERTIARY : ButtonType.SECONDARY"
        (onClick)="toggleSelectionMode()" />
</div>
